/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    Backdrop, Button, Modal, withStyles,
} from '@material-ui/core';
import {
    bool, func, object, shape, string,
} from 'prop-types';
import { setTokenLocalStorage } from '../../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const styles = (theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalHeading: {
        fontWeight: 900,
    },
    modalButtonContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',

        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    modalCancelButton: {
        borderRadius: '100px',
        color: 'white',
        backgroundColor: 'rgba(161, 0, 26, 1)',
        border: '2px solid rgba(161, 0, 26, 1)',
        margin: '5px',

        '&:hover': {
            backgroundColor: 'rgba(179, 44, 44, 1)',
            color: 'white',
            border: '2px solid rgba(179, 44, 44, 1)',
        },
    },
    modalCloseButton: {
        borderRadius: '100px',
        color: 'black',
        border: '2px solid black',
        margin: '5px',

        '&:hover': {
            backgroundColor: 'black',
            border: '2px solid black',
            color: 'white',
        },
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        outline: 'none',
        maxWidth: '500px',
        width: '90%',
        borderRadius: '10px',
    },
});
const AutoRenewalModal = ({
    classes, closeModal, open, userDetails, updateAutoRenewal, setAutoRenewal, setShowModal, trackAutoRenewEvent,
}) => {
    const trackOverlayCloseEvent = () => {
        trackAutoRenewEvent({
            eventCategory: 'account',
            eventAction: 'overlay exited',
            eventLabel: 'passport',
        });
        setAutoRenewal({
            checked: true,
        });
        setShowModal(false);
    };

    const cancelAutoRenew = () => {
        updateAutoRenewal({ emailId: userDetails.email, autoRenewFlag: false });
        setAutoRenewal({ checked: false });
        setShowModal(false);
        trackAutoRenewEvent({
            eventCategory: 'account',
            eventAction: 'pp auto renewal cancelled',
            eventLabel: 'passport',
            eventValue: 1,
        });
        setTokenLocalStorage(true, 'refreshMetadata');
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={open}
            onClose={() => trackOverlayCloseEvent()}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <div className={classes.paper}>
                <p className={classes.modalHeading}>Auto Renew Celebrations Passport</p>
                <p>Are you sure you would like to turn auto renew off for your Celebrations Passport membership?</p>
                <p>If you choose to turn off auto renew, you will be required to manually renew your membership on or before
                    <b> {userDetails?.renewalDate} </b>
                    to continue participation in the program.
                </p>
                <div className={classes.modalButtonContainer}>
                    <Button
                        variant="outlined"
                        color="primary"
                        className={classes.modalCloseButton}
                        onClick={() => closeModal()}
                    >
                        Close
                    </Button>
                    <Button variant="contained" data-testid="cancel-btn-test" color="primary" className={classes.modalCancelButton} onClick={cancelAutoRenew}>
                        Cancel auto renewal
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

AutoRenewalModal.propTypes = {
    classes: object,
    open: bool,
    userDetails: shape({
        renewalDate: string,
    }),
    closeModal: func,
    setShowModal: bool,
    setAutoRenewal: object,
    updateAutoRenewal: func,
    trackAutoRenewEvent: func.isRequired,
};

AutoRenewalModal.defaultProps = {
    classes: {},
    open: false,
    userDetails: {
        renewalDate: '',
    },
    closeModal: () => { },
    setShowModal: false,
    setAutoRenewal: {},
    updateAutoRenewal: () => { },
};

export default withStyles(styles)(AutoRenewalModal);
